// import i18n from '@/i18n'
import { watch } from 'vue'
import store from '@/store'

export function generateTitle (title) {
  return title
}

/**
 * 监听语言的变化，同时 执行 参数方法
 */
export function watchSwitchLang (...cbs) {
  watch(
    () => store.getters.language,
    () => {
      cbs.forEach(cb => cb(store.getters.language))
    }
  )
}
